export default "__VITE_ASSET__C9H7b2d___"